import Sprint from "../../interfaces/sprint/Sprint";
import Ticket from "../../interfaces/ticket/Ticket";
import { ActiveSprintResponse } from "../../interfaces/sprint/ActiveSprintResponse";

export async function getSprints(authToken: string): Promise<Sprint[] | null> {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/sprints`, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            },
        });

        if (!response.ok) {
            console.error("Failed to fetch sprints:", response.status, response.statusText);
            return null;
        }

        return await response.json();
    } catch (error) {
        console.error("Error fetching sprints:", error);
        return null;
    }
}

export async function closeSprint(
    authToken: string,
    sprintId: string,
    summaryNotes: string,
    newSprint: { name: string; startDate: string; endDate: string }
): Promise<Sprint | null> {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/sprints/${sprintId}/close`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
            body: JSON.stringify({ summaryNotes, newSprint }),
        });

        if (!response.ok) {
            console.error("Failed to close sprint:", response.status, response.statusText);
            return null;
        }

        return await response.json();
    } catch (error) {
        console.error("Error closing sprint:", error);
        return null;
    }
}

export async function createSprint(
    authToken: string,
    sprint: { name: string; startDate: string; endDate: string }
): Promise<Sprint | null> {
    try {

        console.log(sprint)
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/sprints`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
            body: JSON.stringify(sprint),
        });

        if (!response.ok) {
            console.error("Failed to create sprint:", response.status, response.statusText);
            return null;
        }

        return await response.json();
    } catch (error) {
        console.error("Error creating sprint:", error);
        return null;
    }
}

export async function getClosedSprints(authToken: string): Promise<Sprint[] | null> {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/sprints/closed`, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            },
        });

        if (!response.ok) {
            console.error("Failed to fetch closed sprints:", response.status, response.statusText);
            return null;
        }

        return await response.json();
    } catch (error) {
        console.error("Error fetching closed sprints:", error);
        return null;
    }
}

export async function getSprintTickets(sprintId: string, authToken: string): Promise<Ticket[] | null> {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/sprints/${sprintId}/tickets`, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            },
        });

        if (!response.ok) {
            console.error("Failed to fetch sprint tickets:", response.status, response.statusText);
            return null;
        }

        return await response.json();
    } catch (error) {
        console.error("Error fetching sprint tickets:", error);
        return null;
    }
}

export async function getActiveSprint(authToken: string): Promise<Sprint | null> {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/sprints/active`, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            },
        });

        if (response.status === 204) { // No Content
            return null;
        }

        if (!response.ok) {
            console.error("Failed to fetch active sprint:", response.status, response.statusText);
            return null;
        }

        // The API returns a complex object, but we only need the sprint for now.
        const activeSprintData: ActiveSprintResponse = await response.json();
        console.log("Active Sprint Data", activeSprintData);
        return activeSprintData.sprint;
    } catch (error) {
        console.error("Error fetching active sprint:", error);
        return null;
    }
}
